export default __webpack_public_path__ + "static/media/imageDesignContentThree.2904b0fa.png";